import {useEffect, useState} from "react";
import debounce from "lodash.debounce";
import axios from "axios";

export const API_ADDRESS = "https://api.foti-immo.ch/api";

export const useFetch = ({endpoint, method = "GET", body = {}}) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const params = {method: method};
    if (method !== "GET") {
        params.body = JSON.stringify(body);
    }

    const fetchData = debounce(async () => {
        try {
            const res = await fetch(`${API_ADDRESS}${endpoint}`, params);
            const json = await res.json();
            setData(json);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, 0);

    useEffect(() => {
        if (!endpoint.includes("//")) {
            fetchData();
        }
        else{
            setLoading(false);
            setError("Incorrect endpoint");
        }

        if (data !== null || error !== null) {
            return fetchData.cancel();
        }
        return fetchData.cancel;
    }, [data, endpoint, error, fetchData]);
    return {data, loading, error};
};

export async function postRequest({endpoint, body = {}}) {
    let data = null;
    let error = null;

    try {
        const res = await axios.post(`${API_ADDRESS}${endpoint}`, body);
        data = await res;
    } catch (err) {
        error = await err.response.data.errors;
    }

    return {data, error};
}

export const fetchAPI = async ({endpoint, method = "GET", body = {}}) => {
    const params = {method: method};
    if (method !== "GET") {
        params.body = JSON.stringify(body);
    }

    return fetch(`${API_ADDRESS}${endpoint}`, params)
        .then(res => res.json())
        .then(json => json);
};
